export enum LocalStateKeys {
  badgeOrderStoreKey = 'BadgeOrderStoreKey',
  badgeWorkInfoStoreKey = 'BadgeWorkInfoStoreKey',
  badgeCostCenterStoreKey = 'badgeCostCenterStoreKey',
  badgeOperationStoreKey = 'badgeOperationStoreKey',

  timeEntryFormWorkInfoStoreKey = 'timeEntryFormWorkInfoStoreKey',
  timeEntryFormOrderStoreKey = 'timeEntryFormOrderStoreKey',
  timeEntryFormCostCenterStoreKey = 'timeEntryFormCostCenterStoreKey',
  timeEntryFormOperationStoreKey = 'timeEntryFormOperationStoreKey',

  multiOrderFormWorkInfoStoreKey = 'multiOrderFormWorkInfoStoreKey',
  multiOrderFormOrderStoreKey = 'multiOrderFormOrderStoreKey',
  multiOrderFormCostCenterStoreKey = 'multiOrderFormCostCenterStoreKey',
  multiOrderFormOperationStoreKey = 'multiOrderFormOperationStoreKey',

  ordersPageOrderStoreKey = 'ordersPageOrderStoreKey',
  ordersPageWorkInfoStoreKey = 'ordersPageWorkInfoStoreKey',
  ordersPageCostCenterStoreKey = 'ordersPageCostCenterStoreKey',
  ordersPagePersonalStoreKey = 'ordersPagePersonalStoreKey',
  ordersSelectionCustomerStoreKey = 'orderSelectionCustomerStoreKey',

  personalDataBranchStoreKey = 'personalDataBranchStoreKey',
  personalDataDepartmentStoreKey = 'personalDataDepartmentStoreKey',
  personalDataHolidayStoreKey = 'personalDataHolidayStoreKey',
  personalDataTimeModelStoreKey = 'personalDataTimeModelStoreKey',
  personalDataWorkInfoStoreKey = 'personalDataWorkInfoStoreKey',
  personalDataOrderStoreKey = 'personalDataOrderStoreKey',
  personalDataCostCenterStoreKey = 'personalDataCostCenterStoreKey',
  personalDataOperationStoreKey = 'personalDataOperationStoreKey',
  personalOverviewPersonalStoreKey = 'personalOverviewPersonalStoreKey',

  personalExpenseOrderKey = 'personalExpenseOrderKey',
  personalExpensePersonalKey = 'personalExpensePersonalKey',
  personalExpenseWorkInfoKey = 'personalExpenseWorkInfoKey',

  personalDefaultWorkWorkInfoStoreKey = 'personalDefaultWorkWorkInfoStoreKey',
  personalDefaultWorkOrderStoreKey = 'personalDefaultWorkOrderStoreKey',
  personalDefaultWorkCostCenterStoreKey = 'personalDefaultWorkCostCenterStoreKey',
  personalDefaultWorkOperationStoreKey = 'personalDefaultWorkOperationStoreKey',

  adminToolsTimeModelStoreKey = 'adminToolsTimeModelStoreKey',
  adminToolsTimeModelReplaceToStoreKey = 'adminToolsTimeModelReplaceToStoreKey',

  adminToolsDepartmentStoreKey = 'adminToolsDepartmentStoreKey',
  adminToolsDepartmentReplaceToStoreKey = 'adminToolsDepartmentReplaceToStoreKey',

  adminToolsHolidayStoreKey = 'adminToolsHolidayStoreKey',
  adminToolsHolidayReplaceToStoreKey = 'adminToolsHolidayReplaceToStoreKey',

  badgePersonalStoreKey = 'badgePersonalStoreKey',
}
